import { isReactNativeApp, subscribeToNative } from '@mobi/web-native-comms/web'
import { coordinateIsValid } from '@core/Areas/VenueMode/Utils/validateCoordinates'
import { updateUserInVenueOnDataLayer } from '@core/Services/Analytics/helpers/dataLayer/updaters'
import { store } from '@core/Store'
import { GeoLocation, geoLocationInitialState, setCoords, setIsEnabledHighAccuracy } from '../Store'
import { findClosestVenue } from '../Utils/geoFenceUtils'
import { venueData } from '../Utils/venueData'
import { startVenueTracking, updateVenueLocation } from './venueTracker'

export function startVenueModeService(): void {
  if (!isReactNativeApp) {
    handleWeb()
  } else {
    handleNative()
  }
}

function handleNative() {
  subscribeToNative(
    'LBS_LAST_KNOWN_LOCATION_UPDATED',
    ({ latitude, longitude, isoCode, mocked, timestamp, accuracy, isPreciseAccuracy }) => {
      const geoLocation: GeoLocation = {
        timestamp,
        latitude: parseFloat(latitude),
        longitude: parseFloat(longitude),
        accuracy,
        isoCode,
        mocked,
        isEnabledHighAccuracy: isPreciseAccuracy,
      }

      updateVenueLocation(geoLocation)
      publish(geoLocation)
    }
  )

  startVenueTracking()
}

function handleWeb() {
  if (!('geolocation' in navigator)) return

  if ('permissions' in navigator) {
    navigator.permissions.query({ name: 'geolocation' }).then(permissionStatus => {
      const handlePermissionChange = () => {
        const isGranted = permissionStatus.state === 'granted'

        // We treat 'granted' as IsEnabledHighAccuracy because the Web Permission API
        // does not provide visibility into 'Coarse' vs 'Fine' granularity like Native does.
        // If the browser grants permission, we assume we can attempt high accuracy.
        store.dispatch(setIsEnabledHighAccuracy(isGranted))

        // If permission is not granted (denied or prompt), invalidate existing geo data
        if (!isGranted) {
          store.dispatch(setCoords(geoLocationInitialState))
        }
      }

      handlePermissionChange()

      permissionStatus.onchange = handlePermissionChange
    })
  }
  const options: PositionOptions = {
    maximumAge: 10 * 1000,
    timeout: 10 * 1000,
    enableHighAccuracy: true,
  }

  navigator.geolocation.watchPosition(
    ({ coords: { latitude, longitude, accuracy }, timestamp }) => {
      const geoLocation: GeoLocation = {
        timestamp,
        latitude,
        longitude,
        accuracy,
        isoCode: '',
        isEnabledHighAccuracy: true,
      }

      updateVenueLocation(geoLocation)
      publish(geoLocation)
    },
    null,
    options
  )

  startVenueTracking()
}

function publish(geoLocation: GeoLocation) {
  const payload: GeoLocation = {
    timestamp: geoLocation.timestamp,
    latitude: geoLocation.latitude,
    longitude: geoLocation.longitude,
    accuracy: geoLocation.accuracy,
    isoCode: geoLocation.isoCode,
    mocked: geoLocation.mocked,
    isEnabledHighAccuracy: geoLocation.isEnabledHighAccuracy,
  }

  // Only update closestVenue if validation succeeds (Accuracy <= threshold)
  if (coordinateIsValid(geoLocation)) {
    const closestVenue = findClosestVenue(geoLocation, venueData)
    payload.closestVenue = closestVenue

    updateUserInVenueOnDataLayer(closestVenue)
  }
  store.dispatch(setCoords(payload))
}
